import {AxiosResponse} from "axios/index";
import $api from "./index";

export function addToFavourites(videoId: string): Promise<AxiosResponse> {
    return $api.post(`video/favourite/${videoId}`)
}

export function removeFromFavourites(videoId: string): Promise<AxiosResponse> {
    return $api.delete(`video/favourite/${videoId}`)
}